import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
import { get } from 'lodash';

export const StyledInfoIcon = styled(FontAwesomeIcon)(({ theme, color }) => ({
  color: color ? get(theme.palette, color) : theme.palette.grey[6],
  fontSize: '1rem',
  marginLeft: 2,
}));
